import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  onInputDate(event: any): void {
    let cursorPosition = event.target.selectionEnd;

    if (event.inputType === 'deleteContentBackward' && (cursorPosition === 2 || cursorPosition === 5)) {
      event.target.value = event.target.value.substring(0, cursorPosition - 1) + event.target.value.substring(cursorPosition);
      cursorPosition --;
    }
    if (event.inputType === 'insertText' && (event.target.value.length > 10)) {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }

    let dateMask = event.target.value.toString();
    dateMask = dateMask.replace(/\D/g, '');

    let mask = '';
    for (let i = 0; i < dateMask.length; i++) {
      mask += dateMask[i];
      if (i === 1 || i === 3) {
        mask += '.';
        if (cursorPosition === 2 || cursorPosition === 5) { cursorPosition++; }
      }
    }
    event.target.value = mask.toString();
    event.target.selectionStart = cursorPosition;
    event.target.selectionEnd = cursorPosition;
  }

}
